import {
  findById as findUserHeaderById,
  getIsLeader,
  getStatusForId,
  getTotalFollowedUsers,
  getTotalFollowers,
  getTotalMomentsCount,
  getTotalPosts,
  viewerCanAccessLeaderEmployeesFeed,
  viewerCanAccessUserStoryline,
  viewerCanDeleteCoverImage,
  viewerCanEditCoverImage,
  viewerCanStartStorylineThread,
} from '@ms/yammer-data/dist/domains/userHeaders/selectors';
import { User } from '@ms/yammer-data/dist/state/types';

import { useSelector } from '../useSelector';

type UseFindUserHeader = (userId: User['id']) => ReturnType<typeof findUserHeaderById>;
export const useFindUserHeader: UseFindUserHeader = (userId) =>
  useSelector((state) => findUserHeaderById(state, userId));

type UseUserHeaderStatus = (userId: User['id']) => ReturnType<typeof getStatusForId>;
export const useUserHeaderStatus: UseUserHeaderStatus = (userId) =>
  useSelector((state) => getStatusForId(state, userId));

type UseTotalFollowers = (userId: User['id']) => ReturnType<typeof getTotalFollowers>;
export const useTotalFollowers: UseTotalFollowers = (userId) =>
  useSelector((state) => getTotalFollowers(state, userId));

type UseTotalFollowedUsers = (userId: User['id']) => ReturnType<typeof getTotalFollowedUsers>;
export const useTotalFollowedUsers: UseTotalFollowedUsers = (userId) =>
  useSelector((state) => getTotalFollowedUsers(state, userId));

type UseViewerCanStartStorylineThread = (
  userId: User['id'] | undefined
) => ReturnType<typeof viewerCanStartStorylineThread>;
export const useViewerCanStartStorylineThread: UseViewerCanStartStorylineThread = (userId) =>
  useSelector((state) => viewerCanStartStorylineThread(state, userId));

type UseViewerCanAccessUserStoryline = (userId: User['id']) => ReturnType<typeof viewerCanAccessUserStoryline>;
export const useViewerCanAccessUserStoryline: UseViewerCanAccessUserStoryline = (userId) =>
  useSelector((state) => viewerCanAccessUserStoryline(state, userId));

type UseTotalPosts = (userId: User['id']) => ReturnType<typeof getTotalPosts>;
export const useTotalPosts: UseTotalPosts = (userId) => useSelector((state) => getTotalPosts(state, userId));

type UseTotalMomentsCount = (userId: User['id']) => ReturnType<typeof getTotalMomentsCount>;
export const useTotalMomentsCount: UseTotalMomentsCount = (userId) =>
  useSelector((state) => getTotalMomentsCount(state, userId));

type UseIsLeader = (userId: User['id']) => ReturnType<typeof getIsLeader>;
export const useIsLeader: UseIsLeader = (userId) => useSelector((state) => getIsLeader(state, userId));

type UseViewerCanEditCoverImage = (userId: User['id']) => boolean;
export const useViewerCanEditCoverImage: UseViewerCanEditCoverImage = (userId) =>
  useSelector((state) => viewerCanEditCoverImage(state, userId));

type UseViewerCanDeleteCoverImage = (userId: User['id']) => boolean;
export const useViewerCanDeleteCoverImage: UseViewerCanDeleteCoverImage = (userId) =>
  useSelector((state) => viewerCanDeleteCoverImage(state, userId));

type UseViewerCanAccessLeaderEmployeesFeed = (userId: User['id']) => boolean;
export const useViewerCanAccessLeaderEmployeesFeed: UseViewerCanAccessLeaderEmployeesFeed = (userId) =>
  useSelector((state) => viewerCanAccessLeaderEmployeesFeed(state, userId));
